import { useLocalization } from "@fluent/react";
import { Button } from "@narmi/design_system";
import { useMarketingTarget } from "byzantine/src/dbbl/businessLogic/modules/marketing/marketing.container";
import { translateMarketingCampaign } from "byzantine";
import BorderCard from "../../../components/BorderCard";
import styles from "./MarketingCard.module.scss";
import type { MarketingCardProps, MarketingTarget } from "./types";

const BorderedMarketingCard = ({ address }: MarketingCardProps) => {
  const { l10n } = useLocalization();
  const { loading, config, linkUrl, opensInNewTab } =
    useMarketingTarget<MarketingTarget>(address);

  if (loading || !config || !linkUrl) {
    return null;
  }

  const translatedCampaign = translateMarketingCampaign(
    {
      uuid: address,
      asset_config: {
        title: config.title,
        body: config.body,
        icon: config.icon,
        linkText: config.linkText
      }
    },
    l10n
  );

  const {
    title,
    body,
    linkText: actionText
  } = translatedCampaign.asset_config || {};

  return (
    <BorderCard title={title}>
      <div className={styles["marketing-card"]}>
        <p>{body}</p>
        <div className={styles["marketing-card-cta"]}>
          <Button
            as="a"
            href={linkUrl}
            kind="plain"
            ariaLabel={`${title} - ${actionText}`}
            label={actionText || "Learn more"}
            testId="marketing-card-learn-more"
            rel="noopener noreferrer"
            target={opensInNewTab ? "_blank" : "_self"}
          />
        </div>
      </div>
    </BorderCard>
  );
};

export default BorderedMarketingCard;
